<template>
  <div class="content-main page-community-rules">
    <div class="rule" v-for="(rule, i) in rules" :key="i+10">
      <div class="first">{{rule.first}}</div>
      <div class="second" v-for="(second, j) in rule.seconds" :key="j + 100">
        <div class="title">{{second.title}}</div>
        <div class="third flex-box" v-for="(third, k) in second.thirds" :key="k + 1000">
          <span>•&nbsp;&nbsp;&nbsp;</span><span>{{third}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default{
  data(){
    return {
      rules: [
        {
          "first": "隐私政策及个人信息保护指引"
        },
        {
          "first": "一. 信息收集",
          "seconds": [
            {"title": "1. 提交报名表时，需自愿填写性别、年龄、城市等个人信息，3天CP将使用您提供的信息为您匹配活动CP。若您不提供相关信息，将无法参与活动。"},
            {
              "title": "2. 在未经用户授权同意的情况下，运营方不会公开或透露用户个人信息，以下情况除外：",
              "thirds": [
                "根据执法单位要求或为公共目的向相关单位提供个人资料", "由于黑客攻击、计算机病毒侵入等不可抗力而造成的个人资料泄露、丢失、被盗用或被窜改等",
                "为免除访问者在生命、身体或财产方面的急迫危险", "为维护运营方的合法权益"
              ]
            }
          ]
        },
        {
          "first": "二. 信息存储",
          "seconds": [
            { "title": "1. 除法律法规或监管部门另有规定外，我们仅在本政策所述目的所必需且最短的时限内存储您的个人信息。"},
            { "title": "2. 如运营方终止服务或运营，我们将及时停止继续收集您个人信息的活动，同时会遵守相关法律法规要求提前向您通知，并在终止服务或运营后对您的个人信息进行删除，但法律法规或监管部门另有规定的除外。"},
            { "title": "3. 运营方在中华人民共和国境内运营中收集和产生的个人信息，存储在中国境内。"}
          ]
        },
        {
          "first": "三. 信息安全",
          "seconds": [
            { "title": "1. 运营方为用户的信息安全提供保障，以防止信息的丢失、不当使用、未经授权访问或披露。"},
            { "title": "2. 运营方将在合理的安全水平内使用各种安全保护措施以保障信息的安全。例如，使用加密技术（例如，SSL）等手段来保护您的个人信息。"},
            { "title": "3. 运营方建立专门的管理制度、流程和组织以保障信息的安全。例如: 严格限制访问信息的人员范围，要求他们遵守保密义务，并进行审查。"}
          ]
        },
        {
          "first": "四. 信息使用",
          "seconds": [
            {"title": "1. 3天CP将使用您提供的信息为您匹配活动CP。"},
            {"title": "2. 如运营方使用您的个人信息，超出了与收集时所声称的目的及具有直接或合理关联的范围，我们将在使用您的个人信息前，再次向您告知并征得您的同意。"}
          ]
        },
        {
          "first": "五. 隐私政策的修订",
          "seconds": [
            {"title": "1. 根据有关法律、法规及规范性文件的修订，或者因运营方发展需要，运营方有权对本协议作出修改或变更，一旦本协议的内容发生变动，运营方将会直接公布修改之后的协议内容，该公布行为视为已经通知用户修改内容。"},
            {"title": "2. 如您不同意对本协议所做的修改，您有权并应当停止使用运营方提供的服务。若您继续使用我们的服务，即表示同意受修订后的隐私政策约束。"}
          ]
        }
      ]
    }
  },
  methods: {
    handleRouter(path){
      this.$router.push(path)
    }
  },
  mounted(){

  }
}

</script>

<style scoped>
.content-main{
  text-align:left;
  color:#222;
  background-color:#fff;
  min-height:100%;
  padding:20px 10px;
}
.rule{margin-bottom:20px;}
.rule .first{font-size:32px;font-weight:bold;margin-bottom:10px;}
.rule .second{padding:0px 10px;}
.rule .second .title{font-size:30px;margin-bottom:3px;margin-top:5px;}
.rule .third{font-size:28px;padding:0px 10px;margin-bottom:2px;align-items:flex-start;}
</style>
